module.exports = __webpack_public_path__ + "static/spotify-3f5abd947bbabdf97ba146997c433c09.jpg";